import { PERMISSION_ACTIONS, PERMISSION_GROUPS, ENTRY_POINTS, createPermissionCheck } from './permission-utils';

export interface ModelPermissionConfig {
  modelName: string;
  basePath: string;
  permissions: {
    VIEW?: boolean;
    UPDATE?: boolean;
    DELETE?: boolean;
    CHANGE_STATUS?: boolean;
    CHANGE_PASSWORD?: boolean;
    IMPORT?: boolean;
    EXPORT?: boolean;
    EDIT?: boolean;
  };
}

export const createModelPermissions = (config: ModelPermissionConfig) => {
  const { modelName, basePath, permissions } = config;

  // We use PERMISSION_GROUPS to form the correct groupValue
  const groupKey = modelName.toUpperCase();
  const groupValue = PERMISSION_GROUPS[groupKey as keyof typeof PERMISSION_GROUPS] || `permission_group_${modelName.toLowerCase()}`;

  const permissionConstants: any = {};

  // Base permissions (always exist)
  if (permissions.VIEW !== false) {
    permissionConstants.VIEW = createPermissionCheck(
      `permission_view_${modelName.toLowerCase()}`,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.VIEW
    );
  }

  if (permissions.UPDATE !== false) {
    permissionConstants.UPDATE = createPermissionCheck(
      `permission_update_${modelName.toLowerCase()}`,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.UPDATE
    );
  }

  if (permissions.DELETE !== false) {
    permissionConstants.DELETE = createPermissionCheck(
      `permission_delete_${modelName.toLowerCase()}`,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.DELETE
    );
  }

  // Additional permissions
  if (permissions.CHANGE_STATUS) {
    // Special handling for different models
    let statusSlug: string;
    if (modelName.toLowerCase() === 'users') {
      statusSlug = 'permission_change_user_status';
    } else {
      statusSlug = `permission_change_${modelName.toLowerCase().replace(/s$/, '')}_status`;
    }

    permissionConstants.CHANGE_STATUS = createPermissionCheck(
      statusSlug,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.CHANGE
    );
  }

  if (permissions.CHANGE_PASSWORD) {
    // Special handling for different models
    let passwordSlug: string;
    if (modelName.toLowerCase() === 'users') {
      passwordSlug = 'permission_change_user_password';
    } else {
      passwordSlug = `permission_change_${modelName.toLowerCase().replace(/s$/, '')}_password`;
    }

    permissionConstants.CHANGE_PASSWORD = createPermissionCheck(
      passwordSlug,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.CHANGE
    );
  }

  if (permissions.IMPORT) {
    permissionConstants.IMPORT = createPermissionCheck(
      `permission_import_${modelName.toLowerCase()}`,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.IMPORT
    );
  }

  if (permissions.EXPORT) {
    permissionConstants.EXPORT = createPermissionCheck(
      `permission_export_${modelName.toLowerCase()}`,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.EXPORT
    );
  }

  if (permissions.EDIT) {
    permissionConstants.EDIT = createPermissionCheck(
      `permission_edit_${modelName.toLowerCase()}`,
      ENTRY_POINTS.LIBRARY,
      groupValue,
      PERMISSION_ACTIONS.EDIT
    );
  }

  return {
    basePath,
    permissions: permissionConstants,
  };
};